import { jsx as _jsx } from "react/jsx-runtime";
import { Provider as AntdProvider } from "../components/common/provider.js";
import { AppTree } from "../components/tree/appTree.js";
import { getDefaultTreeStore } from "../hooks/tree/bridge/rmlMediaBridge.js";
/** Legacy singleton for `window.rml.store`. */ const store = getDefaultTreeStore();
const StoredAppTree = ({ children, useStore: _useStore, ...rest })=>/*#__PURE__*/ _jsx(AntdProvider, {
        children: /*#__PURE__*/ _jsx(AppTree, {
            ...rest,
            children: children
        })
    });
export { store, StoredAppTree };
